export default "__VITE_ASSET__D$mR3Pqc__"